import getSentry from 'utils/Sentry'
import { CenteringDiv } from 'components/generic/HomePageComponents.js'

const { Sentry } = getSentry()
const SentryErrorReportPage = ({ errorEventId }) => (
  <CenteringDiv>
    <>
      <h1>There was an error!</h1>
      <p>
        <a href='#' onClick={() => Sentry.showReportDialog({ eventId: errorEventId })}>
          📣 Report this error
        </a>
      </p>
      <p>
        <a
          href='#'
          onClick={() => {
            window.location.reload(true)
          }}
        >
          Or, try reloading the page
        </a>
      </p>
    </>
  </CenteringDiv>
)

export default SentryErrorReportPage
